var _rect, _path, _rect2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCheckboxControlSelected = function SvgCheckboxControlSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 7,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.3335 12.1481L9.6335 15.1328C9.69545 15.2253 9.77861 15.3017 9.87606 15.3556C9.97351 15.4096 10.0824 15.4394 10.1937 15.4427C10.3051 15.4461 10.4156 15.4228 10.5161 15.3748C10.6166 15.3268 10.7041 15.2554 10.7715 15.1668L16.6668 7.88477",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 7,
    stroke: "currentColor",
    strokeWidth: 2
  })));
};

export { SvgCheckboxControlSelected as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxyZWN0IHg9IjEiIHk9IjEiIHdpZHRoPSIyMiIgaGVpZ2h0PSIyMiIgcng9IjciIGZpbGw9ImN1cnJlbnRDb2xvciIvPgogICAgPHBhdGggZD0iTTcuMzMzNSAxMi4xNDgxTDkuNjMzNSAxNS4xMzI4QzkuNjk1NDUgMTUuMjI1MyA5Ljc3ODYxIDE1LjMwMTcgOS44NzYwNiAxNS4zNTU2QzkuOTczNTEgMTUuNDA5NiAxMC4wODI0IDE1LjQzOTQgMTAuMTkzNyAxNS40NDI3QzEwLjMwNTEgMTUuNDQ2MSAxMC40MTU2IDE1LjQyMjggMTAuNTE2MSAxNS4zNzQ4QzEwLjYxNjYgMTUuMzI2OCAxMC43MDQxIDE1LjI1NTQgMTAuNzcxNSAxNS4xNjY4TDE2LjY2NjggNy44ODQ3NyIKICAgICAgICAgIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CiAgICA8cmVjdCB4PSIxIiB5PSIxIiB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIHJ4PSI3IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIi8+Cjwvc3ZnPg==";